import { render, staticRenderFns } from "./comp_AboutWhisky-A-Header.vue?vue&type=template&id=5f7dee57&scoped=true&"
import script from "./comp_AboutWhisky-A-Header.vue?vue&type=script&lang=js&"
export * from "./comp_AboutWhisky-A-Header.vue?vue&type=script&lang=js&"
import style0 from "./comp_AboutWhisky-A-Header.vue?vue&type=style&index=0&id=5f7dee57&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7dee57",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
